import { useNavigate } from 'react-router-dom';
import Project from '../Components/Project';
import '../Components/Project.css';
import projectOneCover from '../assets/projectOne/mainImg.jpg';
import projectTwoCover from '../assets/projectTwo/mainImg.jpg';
import projectThreeCover from '../assets/projectThree/mainImg.jpg';
import projectFourCover from '../assets/projectFour/mainImg.jpg';
import projectFiveCover from '../assets/projectFive/mainImg.jpg';
import projectSixCover from '../assets/projectSix/mainImg.jpg';
import projectSevenCover from '../assets/projectSeven/mainImg.jpg';
import projectOtherCover from '../assets/otherProjects/mainImg.jpg';
import projectEightCover from '../assets/projectEight/mainImg.jpg';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

function Projects() {

    const navigate = useNavigate();
    function viewDetails(projectID) {
        navigate('/project-details', { state: { projectID } });
    }

    function scrollLeft() {
        const scrollContainer = document.querySelector(".allProjects");
        scrollContainer.scrollBy({
            left: -1000,
            behavior: "smooth",
        });
    }

    function scrollRight(){
        const scrollContainer = document.querySelector(".allProjects");
        scrollContainer.scrollBy({
            left: 1000,
            behavior: "smooth",
        });
    }

    return(
        <div className = "projects">
            <h1>Projekti</h1>
            <p>Dobrodošli na stranicu projekata Wolf Enterijeri, gdje možete istražiti naše najnovije
                i najinspirativnije radove. Naša strast za dizajn enterijera i inovativnim pristupom svakom
                projektu rezultira stvaranjem prostora koji zadovoljavaju i nadmašuju očekivanja naših klijenata.
                U nastavku možete pronaći pregled nekih od naših nedavnih projekata, koji odslikavaju našu 
                predanost kvalitetu i estetici.
            </p>

            <div className = "projectsContainer">
                <FontAwesomeIcon 
                    icon={faChevronLeft} 
                    className="scroll-btn left" 
                    onClick={scrollLeft} 
                />

                <div className = "allProjects">
                <Project
                    image={projectOneCover}
                    viewDetails={() => viewDetails("proj1")}
                />

                <Project
                    image={projectTwoCover}
                    viewDetails={() => viewDetails("proj2")}
                />

                <Project
                    image={projectEightCover}
                    viewDetails={() => viewDetails("proj8")}
                />

                <Project 
                    image = {projectThreeCover}
                    viewDetails={() => viewDetails("proj3")}
                />

                <Project
                    image={projectFourCover}
                    viewDetails={() => viewDetails("proj4")}
                />

                <Project
                    image={projectFiveCover}
                    viewDetails={() => viewDetails("proj5")}
                />

                <Project
                    image={projectSixCover}
                    viewDetails={() => viewDetails("proj6")}
                />

                <Project
                    image={projectSevenCover}
                    viewDetails={() => viewDetails("proj7")}
                />

                <Project
                    image={projectOtherCover}
                    viewDetails={() => viewDetails("other")}
                />
     
            </div>
            
            <FontAwesomeIcon 
                icon={faChevronRight}
                className = "scroll-btn right" 
                onClick ={scrollRight}
            />
                
            </div>
            
        </div>
    );
}

export default Projects;